import { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { Container } from 'lib/components';

export interface GettingStartedContentProps extends HTMLAttributes<HTMLDivElement> {}

export const GettingStartedContent: FC<GettingStartedContentProps> = ({ className, children, ...props }) => (
  <div className={classNames('getting-started__content flex-grow', className)} {...props}>
    <Container>{children}</Container>
  </div>
);
